import { useState } from "react";
import toast from "react-hot-toast";
import { useOpenSessionMutation } from "@/redux/services/pos/registerSession.api";
import { parseMoneyToCents } from "@/lib/utils";
import { Button } from "@/components/ui/button";

interface OpenSessionFormProps {
  restaurantId: string;
}

const OpenSessionForm = ({ restaurantId }: OpenSessionFormProps) => {
  const [openingBalance, setOpeningBalance] = useState<string>("");
  const [notes, setNotes] = useState<string>("");

  const [openSession, { isLoading }] = useOpenSessionMutation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const balanceCents = parseMoneyToCents(openingBalance);
    if (balanceCents === null || balanceCents < 0) {
      toast.error("Veuillez entrer un montant valide");
      return;
    }

    try {
      await openSession({
        restaurantId,
        data: {
          openingBalance: balanceCents,
          ...(notes.trim() ? { notes: notes.trim() } : {}),
        },
      }).unwrap();

      toast.success("Caisse ouverte avec succès");
    } catch {
      toast.error("Une erreur s'est produite lors de l'ouverture de la caisse");
    }
  };

  return (
    <div className="flex items-center justify-center py-12">
      <div className="dash__card w-full max-w-md p-6">
        <h3 className="text-lg font-semibold text-center mb-6">
          Aucune caisse ouverte
        </h3>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              htmlFor="openingBalance"
              className="block text-sm font-medium text-card-foreground mb-1"
            >
              Fond de caisse
            </label>
            <input
              id="openingBalance"
              type="text"
              inputMode="numeric"
              placeholder="0"
              value={openingBalance}
              onChange={(e) => setOpeningBalance(e.target.value)}
              className="w-full rounded-lg border border-border px-4 py-3 text-lg focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
            />
          </div>

          <div>
            <label
              htmlFor="notes"
              className="block text-sm font-medium text-card-foreground mb-1"
            >
              Notes (optionnel)
            </label>
            <textarea
              id="notes"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              rows={3}
              placeholder="Notes..."
              className="w-full rounded-lg border border-border px-4 py-3 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
            />
          </div>

          <Button
            type="submit"
            disabled={isLoading}
            isLoading={isLoading}
            className="w-full"
            size="xl"
          >
            Ouvrir la caisse
          </Button>
        </form>
      </div>
    </div>
  );
};

export default OpenSessionForm;
